import { Environment } from './environment';

export const stagingEnvironment: Environment = {
  name: 'staging',
  auth0Domain: 'login-stg.sama.com',
  auth0ClientId: 'KIEwFNC8dPFZxkYBAqRGkHzQ34vEfJaJ',
  annotationStoreServiceBaseUrl:
    'https://annotation-store-stg.krypton.sama.com/v1',
  clientCalibrationBaseUrl: 'https://client-calibration-be.stg.sama.com/api/v0',
  taskServiceBaseUrl: 'https://sama-tasks-stg.krypton.sama.com/api/v0',
  assetServiceBaseUrl: 'https://kaguya-stg.krypton.sama.com',
  authorizationServiceBaseUrl:
    'https://sama-authorization-server-stg.krypton.sama.com',
  autoQaServiceBaseUrl: 'https://auto-qa-stg.krypton.samasource.com',
  checkShaderErrors: false,
  draftSavePeriod: 60_000,
  featureFlagServiceBaseUrl: 'https://sama-lab-sandbox.lithium.sama.com/v2.0',
  outputMinHeight: 800,
  // Match Kaguya asset ID in sh3 seed data
  previewWorkspacePointCloudAssetUrl:
    'https://kaguya-stg.krypton.sama.com/api/v1/assets/60a55349-6176-4910-953e-989ae4c5d587',
  targetEnhancedPointCount: 1_000_000,
  samplingBackendServiceBaseUrl: 'https://sampling-be-stg.krypton.sama.com',
  samplingPortalServiceBaseUrl: 'https://portal.stg.sama.com',
  // Match sh3 seed data
  seedDataPointCloudTaskId: '6542a79881a16e8609784c39',
  seedDataSensorFusionTaskId: '6542a7d11c88e0f55c5e4661',
  settingsServiceBaseUrl: 'https://sama-settings-be.stg.sama.com/api/v0',
  sh3BaseUrl: 'https://api.stg.sama.com',
  shouldDebounceRendering: true,
  shouldForceWebglContextLoss: true,
  shouldMakeHackyStoreForImageAnnotationTests: false,
  shouldSendDebugLogs: false,
  shouldSendErrorsToRollbar: true,
  shouldShowAddRandomShapes: false,
  shouldUseSegmentTracker: true,
  shouldUseResizeObserver: true,
};
